import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import type { CookieConsentService } from '../../../application/CookieConsentService';
import { makeContext } from '../makeContext';

const { Provider, useContext } = makeContext<CookieConsentService>(
  'CookieConsentService',
);

export const CookieConsentServiceProvider = ({
  value: service,
  children,
}: {
  value: CookieConsentService;
  children: React.ReactNode;
}) => {
  const [gaveConsent, setGaveConsent] = useState(false);
  useEffect(() => {
    setGaveConsent(service.gaveConsent);
  }, [service]);

  const consent = useCallback(() => {
    service.consent();
    setGaveConsent(true);
  }, [service]);

  return <Provider value={{ consent, gaveConsent }}>{children}</Provider>;
};

export const useCookieConsentService = useContext;
